#### Job ad preview

We’ve extended [Job Posting] with the ability to [preview a job ad] before it’s posted or updated.
This allows the hirer to understand how their job ad would be displayed in SEEK’s search results and job details page.

```graphql
query ($positionProfile: PostedPositionProfilePreview_PositionProfileInput!) {
  postedPositionProfilePreview(positionProfile: $positionProfile) {
    previewUri {
      url
    }
  }
}
```

```json
{
  "positionProfile": {
    "positionTitle": "Senior Developer",
    "positionOrganizations": "seekAnzPublicTest:organization:seek:93WyyF1h",
    "jobCategories": "seekAnzPublicTest:jobCategory:seek:2EFstqFvP",
    "positionLocation": "seekAnzPublicTest:location:seek:2FqwWaaMV",
    "offeredRemunerationPackage": {
      "descriptions": ["Base + Super + Profit Share"]
    },
    "postingInstructions": [
      {
        "seekAdvertisementProductId": "globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbByJ1JVteAQQkfa3uMJLPJ",
        "brandingId": "globalPublicTest:advertisementBranding:hirerBranding:5DU2L2vQsyTXuu9NEUKT3f"
      }
    ],
    "positionFormattedDescriptions": [
      {
        "descriptionId": "AdvertisementDetails",
        "content": "My job ad details"
      },
      {
        "descriptionId": "SearchSummary",
        "content": "Search summary content"
      },
      {
        "descriptionId": "SearchBulletPoint",
        "content": "Search bullet point 1"
      },
      {
        "descriptionId": "SearchBulletPoint",
        "content": "Search bullet point 2"
      },
      {
        "descriptionId": "SearchBulletPoint",
        "content": "Search bullet point 3"
      }
    ],
    "seekAnzWorkTypeCode": "FullTime",
    "seekVideo": {
      "url": "https://www.youtube.com/watch?v=vsLYc3gzMzw",
      "seekAnzPositionCode": "Below"
    }
  }
}
```

```json lovato-ignore-runnable-graphql-operation
{
  "postedPositionProfilePreview": {
    "previewUri": {
      "url": "https://job-ad-preview.seek.com/anzPublicTest?id=seekAnzPublicTest:postedPositionProfilePreview:seekApi:37EWfWxhwVEGTT5BcjfE2L"
    }
  }
}
```

[job posting]: /use-cases/job-posting
[preview a job ad]: /use-cases/job-posting/managing-job-ads/previewing-a-job-ad
